export function positionProsts(timelineElements, forComments, forCommentComments, communityType) {
    var elements = $.parseJSON(timelineElements);
    if (elements !== null) {
        $.each(elements, function (key, value) {
            var container = $("#" + value.id + ".timeline_entry");
            var prostLink = container.find(".prost_link");
            if (forCommentComments) {
                container = $(".display_comment_comment#comment_comment_" + value);
                prostLink = container.find(".prost_link.comment_comment");
            } else if (forComments) {
                container = $(".display_comment#comment_" + value);
                prostLink = container.find(".prost_link.comment");
            }
            // prostLink.html("<i class='icon icon-prost' aria-hidden='true'></i> <span class=\"prost_count\" aria-hidden=\"true\"></span>");
            prostLink.removeClass("prost_link");
            prostLink.addClass("un_prost_link");
            prostLink.addClass("active");
        });
    }
}